import axios from "axios";

// Use REACT_APP_LOGINURL which always gives base URL with /api/
const BASE_URL = process.env.REACT_APP_LOGINURL || "http://localhost:3005/api/";

// Construct complaints API URLs
const API_URL = BASE_URL.replace(/\/$/, '') + '/complaints';
const API_URL_UPLOAD = BASE_URL.replace(/\/$/, '') + '/complaints/upload';

const headers = {
  'Content-Type': 'application/json',
  'token': localStorage.getItem("session-id")
}

const headersUpload = {
  'token': localStorage.getItem("session-id")
}

/** CSV export — response.data.data.csv and .filename */
const exportComplaints = (postData) => {
  var payload = {
    functionName: "ExportComplaints",
    postData: postData
  };
  return axios.post(API_URL, payload, { headers });
};

// Get all complaints with filters
const getComplaints = (postData) => {
  var payload = {
    functionName: "GetComplaints",
    postData: postData
  }
  return axios.post(API_URL, payload, { headers });
};

// Get single complaint details
const getComplaint = (complaintId) => {
  var payload = {
    functionName: "GetComplaint",
    postData: {
      complaint_id: complaintId
    }
  }
  return axios.post(API_URL, payload, { headers });
};

// Create complaint (with Base64 attachment support)
const createComplaint = (formData) => {
  // Check if attachments are Base64 (from frontend conversion) or files
  const hasBase64Attachments = formData.attachments && formData.attachments.length > 0 && 
    formData.attachments[0].data && formData.attachments[0].data.startsWith('data:');
  
  if (hasBase64Attachments) {
    // Send as JSON with Base64 attachments (similar to profile_image)
    var payload = {
      functionName: "CreateComplaint",
      postData: {
        customer_id: formData.customer_id,
        external_customer: !!formData.external_customer,
        customer_name: formData.customer_name || "",
        customer_email: formData.customer_email || "",
        category: formData.category,
        priority: formData.priority,
        subject: formData.subject,
        description: formData.description,
        attachments: formData.attachments // Array of {filename, data: "data:..."}
      }
    };
    if (formData.order_id) {
      payload.postData.order_id = formData.order_id;
    }
    return axios.post(API_URL, payload, { headers });
  } else {
    // Legacy: Send as FormData with file objects (for backward compatibility)
    var formDataToSend = new FormData();
    formDataToSend.append("functionName", "CreateComplaint");
    formDataToSend.append("external_customer", formData.external_customer ? "true" : "false");
    if (formData.external_customer) {
      formDataToSend.append("customer_name", formData.customer_name || "");
      formDataToSend.append("customer_email", formData.customer_email || "");
    } else {
      formDataToSend.append("customer_id", formData.customer_id || "");
    }
    formDataToSend.append("category", formData.category);
    formDataToSend.append("priority", formData.priority);
    formDataToSend.append("subject", formData.subject);
    formDataToSend.append("description", formData.description);
    if (!formData.external_customer && formData.order_id) {
      formDataToSend.append("order_id", formData.order_id);
    }
    
    // Add attachments if any
    if (formData.attachments && formData.attachments.length > 0) {
      formData.attachments.forEach((file, index) => {
        formDataToSend.append(`attachment_${index}`, file);
      });
    }
    
    return axios.post(API_URL_UPLOAD, formDataToSend, { headers: headersUpload });
  }
};

// Add reply to complaint (with Base64 attachment support)
const addReply = (formData) => {
  // Check if attachments are Base64 (from frontend conversion) or files
  const hasBase64Attachments = formData.attachments && formData.attachments.length > 0 && 
    formData.attachments[0].data && formData.attachments[0].data.startsWith('data:');
  
  if (hasBase64Attachments) {
    // Send as JSON with Base64 attachments (similar to profile_image)
    var payload = {
      functionName: "AddReply",
      postData: {
        complaint_id: formData.complaint_id,
        message: formData.message,
        attachments: formData.attachments // Array of {filename, data: "data:..."}
      }
    };
    if (formData.status) {
      payload.postData.status = formData.status;
    }
    return axios.post(API_URL, payload, { headers });
  } else {
    // Legacy: Send as FormData with file objects (for backward compatibility)
    var formDataToSend = new FormData();
    formDataToSend.append("functionName", "AddReply");
    formDataToSend.append("complaint_id", formData.complaint_id);
    formDataToSend.append("message", formData.message);
    if (formData.status) {
      formDataToSend.append("status", formData.status);
    }
    
    // Add attachments if any
    if (formData.attachments && formData.attachments.length > 0) {
      formData.attachments.forEach((file, index) => {
        formDataToSend.append(`attachment_${index}`, file);
      });
    }
    
    return axios.post(API_URL_UPLOAD, formDataToSend, { headers: headersUpload });
  }
};

// Update complaint (status, priority, reassign, internal notes)
const updateComplaint = (postData) => {
  var payload = {
    functionName: "UpdateComplaint",
    postData: postData
  }
  return axios.post(API_URL, payload, { headers });
};

// Close complaint with resolution
const closeComplaint = (complaintId, resolutionSummary) => {
  var payload = {
    functionName: "CloseComplaint",
    postData: {
      complaint_id: complaintId,
      resolution_summary: resolutionSummary
    }
  }
  return axios.post(API_URL, payload, { headers });
};

// Get complaint categories
const getCategories = () => {
  var payload = {
    functionName: "GetComplaintCategories",
    postData: {}
  }
  return axios.post(API_URL, payload, { headers });
};

// Get complaint statuses
const getStatuses = () => {
  var payload = {
    functionName: "GetComplaintStatuses",
    postData: {}
  }
  return axios.post(API_URL, payload, { headers });
};

// Get complaint priorities
const getPriorities = () => {
  var payload = {
    functionName: "GetComplaintPriorities",
    postData: {}
  }
  return axios.post(API_URL, payload, { headers });
};

// Delete complaint (Admin)
const deleteComplaint = (id) => {
  var payload = {
    functionName: "DeleteComplaint",
    postData: {
      _id: id
    }
  }
  return axios.post(API_URL, payload, { headers });
};

// Get complaint discussion/comments (Admin) - Optimized API
const getComplaintDiscussion = (complaintId) => {
  var payload = {
    functionName: "GetComplaintDiscussion",
    postData: {
      complaint_id: complaintId
    }
  }
  return axios.post(API_URL, payload, { headers });
};

const ComplaintsService = {
  getComplaints,
  getComplaint,
  createComplaint,
  addReply,
  updateComplaint,
  closeComplaint,
  deleteComplaint,
  exportComplaints,
  getCategories,
  getStatuses,
  getPriorities,
  getComplaintDiscussion
}

export default ComplaintsService;

